const teamRequestStatus = {
  requested: 'angefragt',
  accepted: 'Mitglied',
};

export default teamRequestStatus;
